import { format, isValid, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { getLocalTimeZone } from './date';

/**
 * Localize the given UTC date to an ISO string in the local timezone.
 *
 * @param {string} date - The input ISO UTC date string.
 * @returns {string} - The ISO string in local time (e.g., '2024-08-20T09:56:59.287').
 */
export const localizeUTC = (date: string): string => {
  if (!date) {
    return '';
  }

  const utcDate = parseISO(date);

  if (!isValid(utcDate)) {
    return '';
  }

  const localTimezone = getLocalTimeZone();

  const zonedDate = toZonedTime(utcDate, localTimezone);

  return format(zonedDate, "yyyy-MM-dd'T'HH:mm:ss.SSS");
};
